import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { TeamCrest } from '@/components/ui';
import { queries } from '@/lib/api';

export function SecaoSobre() {
  const teamsQuery = useQuery(queries.teams());
  const editionsQuery = useQuery(queries.tournaments());
  const teams = teamsQuery.data?.teams ?? [];
  const editions = editionsQuery.data?.tournaments ?? [];
  const teamValue = (value: number) => teamsQuery.isPending ? '…' : teamsQuery.isError ? '—' : value;
  const editionValue = (value: number) => editionsQuery.isPending ? '…' : editionsQuery.isError ? '—' : value;
  const numbers = [
    { label: 'Times na comunidade', value: teamValue(teams.length) },
    { label: 'Edições concluídas', value: editionValue(editions.filter(t => t.status === 'finished').length) },
    { label: 'Edições em disputa', value: editionValue(editions.filter(t => ['registration', 'ready', 'group_stage', 'knockout'].includes(t.status)).length) },
    { label: 'Clubes verificados na EA', value: teamValue(teams.filter(t => t.eaVerifiedAt).length) },
  ];
  return <section id="sobre" className="home-about" aria-labelledby="home-about-title">
    <div className="container">
      <div className="home-about-layout">
        <div className="home-about-story">
          <h2 id="home-about-title">O jogo é virtual.<br /><em>A competição é real.</em></h2>
          <p>A Hexa Cup é uma competição de Pro Clubs feita para quem joga. Do sorteio ao apito final, seu time acompanha cada etapa da disputa.</p>
          <ul className="home-about-principles"><li>Sorteio que qualquer um confere.</li><li>Tabela atualizada a cada resultado.</li><li>Estatísticas do próprio EA SPORTS FC.</li></ul>
          <Link className="home-about-link" to="/regulamento">Conheça o regulamento <span aria-hidden="true">→</span></Link>
        </div>
        <div className="home-about-record">
          <h3>A Hexa Cup em campo</h3>
          <dl>{numbers.map(n => <div key={n.label}><dt>{n.label}</dt><dd>{n.value}</dd></div>)}</dl>
          {(teamsQuery.isError || editionsQuery.isError) && <p className="home-about-feedback">Alguns dados não carregaram. <button onClick={() => { void teamsQuery.refetch(); void editionsQuery.refetch(); }}>Tentar novamente</button></p>}
          <Link className="home-about-link" to="/campeonatos">Acompanhar campeonatos <span aria-hidden="true">→</span></Link>
        </div>
      </div>
      <div className="home-about-clubs">
        <div className="home-about-clubs-heading"><h3>Quem faz a disputa acontecer</h3><Link className="home-about-link" to="/times">Todos os times <span aria-hidden="true">→</span></Link></div>
        {teamsQuery.isPending ? <p role="status">Carregando times…</p> : teamsQuery.isError ? <p>Os clubes estão temporariamente indisponíveis.</p> : teams.length ? <ul className="home-about-club-list">{teams.slice(0,12).map(t => <li key={t.id}><Link to={'/times/'+t.slug}><TeamCrest team={t} size="md" /><span>{t.shortName || t.name}</span></Link></li>)}</ul> : <p>Os primeiros times aparecerão aqui após o cadastro. <Link className="home-about-link" to="/cadastrar-time">Cadastre seu time</Link></p>}
      </div>
    </div>
  </section>;
}
